import { render } from "./About.vue?vue&type=template&id=a12ae1d6"
const script = {}
script.render = render

export default script